import { b as o } from "./-chunk-@lit.js";
import { B as i, T as l } from "./-chunk-lit-html.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class r extends o {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
  }
  createRenderRoot() {
    var t;
    const e = super.createRenderRoot();
    return (t = this.renderOptions).renderBefore ?? (t.renderBefore = e.firstChild), e;
  }
  update(e) {
    const t = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(e), this._$Do = i(t, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    var e;
    super.connectedCallback(), (e = this._$Do) == null || e.setConnected(!0);
  }
  disconnectedCallback() {
    var e;
    super.disconnectedCallback(), (e = this._$Do) == null || e.setConnected(!1);
  }
  render() {
    return l;
  }
}
var n;
r._$litElement$ = !0, r.finalized = !0, (n = globalThis.litElementHydrateSupport) == null || n.call(globalThis, { LitElement: r });
const s = globalThis.litElementPolyfillSupport;
s == null || s({ LitElement: r });
(globalThis.litElementVersions ?? (globalThis.litElementVersions = [])).push("4.1.1");
export {
  r
};
